import { createSelector } from 'reselect'
import FilterOption from '../../../entities/FilterOption'
import filterListSelector from '../filterListSelector'
import filtersSelector from '../filtersSelector'
import carlineFiltersSelector from './carlineFiltersSelector'

const carlineFilterOptionsSelector = createSelector(
    filterListSelector,
    carlineFiltersSelector,
    filtersSelector,
    (filterList, carlineFilters, appliedFilters): FilterOption[] => {
        if (!filterList || !carlineFilters) {
            return []
        }

        const allAttributes = carlineFilters.flatMap((carline) =>
            carline.attributesSet.flatMap((set) => set.attributes) || [],
        )

        const filterOptions = filterList
            .filter((filter) => allAttributes.some(attr => attr[filter.attribute] !== undefined))
            .map((filter) => {
                const values = new Set<string | number>()
                const activeValues = appliedFilters[filter.attribute] || []
                const otherActiveFilters = Object.entries(appliedFilters)

                const availableModels = allAttributes.filter((modelAttribute) => {
                    return otherActiveFilters.every(([filterKey, filterValues]) => {
                        if (filterValues.length === 0 || filterKey === filter.attribute) {
                            return true
                        }
                        
                        const modelValue = modelAttribute[filterKey]
                        if (modelValue === undefined) {
                            return false
                        }

                        const otherFilterConfig = filterList.find(f => f.attribute === filterKey)
                        
                        if (otherFilterConfig?.type === 'max') {
                            const numericModelValue = parseFloat(modelValue)
                            const selectedMaxValue = filterValues[0]
                            const numericMaxValue = typeof selectedMaxValue === 'string' ? parseFloat(selectedMaxValue) : selectedMaxValue
                            
                            return !isNaN(numericModelValue) && 
                                   !isNaN(numericMaxValue) &&
                                   numericModelValue <= numericMaxValue
                        } else {
                            return filterValues.includes(modelValue)
                        }
                    })
                })

                availableModels.forEach((modelAttribute) => {
                    const value = modelAttribute[filter.attribute]
                    if (value !== undefined) {
                        if (filter.type === 'max') {
                            const numValue = parseFloat(value)
                            if (!isNaN(numValue)) {
                                values.add(numValue)
                            } else {
                                values.add(value)
                            }
                        } else {
                            values.add(value)
                        }
                    }
                })

                return {
                    attribute: filter.attribute,
                    type: filter.type,
                    values: Array.from(values),
                    activeValues,
                }
            })

        return filterOptions
    },
)

export default carlineFilterOptionsSelector
